import * as React from 'react'

import { type IParseFile, ImporterSession as nuvoSession } from '@ingestro/importer-react'
import { UniversalImporterValueObjectsImportTypeEnum } from 'generated/resources/graphql'

interface UseFileUploadProps {
  importType: UniversalImporterValueObjectsImportTypeEnum
  onFileUpload?: (file: File) => void
}

export const useFileUpload = ({ importType, onFileUpload }: UseFileUploadProps) => {
  const [parsedFile, setParsedFile] = React.useState<IParseFile[] | undefined>(undefined)
  const [parseFileLoading, setParseFileLoading] = React.useState<boolean>(false)

  const handleFileUpload = async (uploadedFile: File[] | undefined) => {
    if (!uploadedFile || !uploadedFile[0]) return

    setParseFileLoading(true)
    const nuvoParsed = await nuvoSession.parse({ data: uploadedFile, identifier: importType })
    setParsedFile(nuvoParsed.accepted)
    setParseFileLoading(false)

    onFileUpload?.(uploadedFile[0])
  }

  return {
    parsedFile,
    parseFileLoading,
    handleFileUpload,
  }
}
